module.exports = __webpack_public_path__ + "assets/6068ce6ba6477147ddb6faab8bea361a.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/taylorice/Documents/Roc2/engine/public-src/spingames/panel/sounds/buttons/spin.mp3
 ** module id = 30
 ** module chunks = 0
 **/